import i18n from 'services/base/i18n';

export default {
  // Link to the page to edit the details for this device
  edit: () => i18n.pgettext('Pages|View Device', 'EDIT'),
  // The title for this page
  deviceInfoTitle: () => i18n.pgettext('Pages|View Device', 'DEVICE INFO'),
  // Label for the IP Address of this device
  ipAddressLabel: () => i18n.pgettext('Pages|View Device', 'IP ADDRESS'),
  // Label for the mac address of this device
  macAddressLabel: () => i18n.pgettext('Pages|View Device', 'MAC ADDRESS'),
  // Label for the detected device type (e.g. Desktop, Laptop, Printer, etc) of this device
  deviceTypeLabel: () => i18n.pgettext('Pages|View Device', 'DEVICE TYPE'),
  // Label for the operating system for this device
  operatingSystemLabel: () => i18n.pgettext('Pages|View Device', 'OPERATING SYSTEM'),
  // Label for the name of the pangolin this device is connected to
  connectedToLabel: () => i18n.pgettext('Pages|View Device', 'CONNECTED TO'),
  // Label for when this device was last seen connected
  lastSeenLabel: () => i18n.pgettext('Pages|View Device', 'LAST SEEN'),
  // Header for the device permissions section
  devicePermissionTitle: () => i18n.pgettext('Pages|View Device', 'DEVICE PERMISSION'),
  // Whether this device should be allowed to access the internet
  blockInternet: () => i18n.pgettext('Pages|View Device', 'Block internet access'),
  // Whether the Pangolin should be allowed to access other devices
  blockInternal: () => i18n.pgettext('Pages|View Device', 'Quarantine from other devices'),
  // Whether the Pangolin should ignore parental control rules for this device
  ignoreSchedules: () => i18n.pgettext('Pages|View Device', 'Bypass parental control rules'),
  // Whether the Pangolin should ignore this device completely
  ignoreAll: () => i18n.pgettext('Pages|View Device', 'Disable interception and filtering'),
  // Whether we should send the application notifications whenever this device connects to the network
  notifyOnUp: () => i18n.pgettext('Pages|View Device', 'Alert me when device is online'),
  // Header for the optional features section
  optionalFeaturesTitle: () => i18n.pgettext('Pages|View Device', 'OPTIONAL FEATURES'),
  // Whether the Pangolin should block ads for this device
  blockAdTracking: () => i18n.pgettext('Pages|View Device', 'Block ads and tracking'),
  // Whether the Pangolin should block malicious traffic for this device
  blockMaliciousTraffic: () => i18n.pgettext('Pages|View Device', 'Block malicious servers'),
  // Whether the Pangolin should apply masquerading for this device
  masquerade: () => i18n.pgettext('Pages|View Device', 'Enable masquerading'),
  // This string gets displayed if the Pangolin doesn't remember when it last saw this device
  lastSeenUnknown: () => i18n.pgettext('Pages|View Device', 'Unknown'),

  // This is one of the possible device types
  desktop: () => i18n.pgettext('Pages|View Device', 'Personal Computer'),
  // This is one of the possible device types
  mobile: () => i18n.pgettext('Pages|View Device', 'Mobile Device'),
  // This is one of the possible device types
  gaming: () => i18n.pgettext('Pages|View Device', 'Gaming Console'),
  // This is one of the possible device types
  media: () => i18n.pgettext('Pages|View Device', 'Media Device'),
  // This is one of the possible device types
  network: () => i18n.pgettext('Pages|View Device', 'Network Device'),
  // This is one of the possible device types
  camera: () => i18n.pgettext('Pages|View Device', 'Camera'),
  // This is one of the possible device types
  printer: () => i18n.pgettext('Pages|View Device', 'Printer'),
  // This is one of the possible device types
  vpn: () => i18n.pgettext('Pages|View Device', 'VPN'),
  // This is one of the possible device types
  misc: () => i18n.pgettext('Pages|View Device', 'Miscellaneous'),
  // This is one of the possible device types. It shows up when the Pangolin has no idea what it is.
  unknown: () => i18n.pgettext('Pages|View Device', 'Unknown Device'),
};
